module.exports = __webpack_public_path__ + "img/pirgeometro.6cd946af.webp";